import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import Neuralia369TesixHub from '../components/admin/Neuralia369TesixHub';
import { useAuth } from '../context/AuthContext';

export default function NeuraliaTesixPage() {
  const { user, loading, authFetch } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) navigate('/login');
  }, [user, loading, navigate]);

  if (loading || !user) return null;

  return (
    <>
      <SEO
        title="Neuralia369Tesix"
        description="Flujo de Trabajo — Neuralia369 Tesix. Centro interno para estructura, metodología, WordLab, fuentes, revisión y entregas académicas." 
      />
      <div className="min-h-screen px-4 pb-16 pt-24" data-testid="tesix-page">
        <div className="mx-auto max-w-7xl">
          <Neuralia369TesixHub authFetch={authFetch} />
        </div>
      </div>
    </>
  );
}